var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createModel } from '../../models';
import { defaultCacheModelOptions } from '../defaults';
import { createInvalidator } from '../tasks/invalidator';
import { createPurger } from '../tasks/purger';
import { createCacheEnhancer } from './cacheEnhancer';
import { resourceReducer } from './cacheReducer';
import { ResourceCacheImplementation } from './cacheImplementation';
import { dehydrateResourceState } from './dehydrateResourceState';
export function createResourceCacheModel(options) {
    if (options === void 0) { options = {}; }
    var _a = __assign(__assign({}, defaultCacheModelOptions), options), getScope = _a.getScope, defaultContext = _a.defaultContext, defaultInvalidator = _a.defaultInvalidator, defaultPurger = _a.defaultPurger, defaultRequestPolicy = _a.defaultRequestPolicy, _b = _a.namespace, namespace = _b === void 0 ? 'resourceCache' : _b;
    return createModel({
        reducer: resourceReducer,
        defaultProps: {
            context: defaultContext,
        },
        dehydrater: function (outlet) {
            return outlet
                .filter(function (value) {
                return !Object.values(value.tasks.pending).some(function (task) {
                    return ['manualLoad', 'load'].includes(task.type);
                });
            })
                .map(dehydrateResourceState);
        },
        enhancer: createCacheEnhancer({
            tasks: {
                invalidate: typeof defaultInvalidator === 'number'
                    ? createInvalidator({
                        intervalFromTimestamp: defaultInvalidator,
                    })
                    : defaultInvalidator,
                purge: typeof defaultPurger === 'number'
                    ? createPurger({
                        ttl: defaultPurger,
                    })
                    : defaultPurger,
            },
        }),
        namespace: namespace,
        selectError: function (state) { return state.error; },
        factory: function (outlet, dispatch, props) {
            var context = props.context;
            var scope = getScope ? getScope(context) : 'default';
            var cache = new ResourceCacheImplementation(context, defaultRequestPolicy, dispatch, outlet, scope);
            return {
                request: cache.request.bind(cache),
            };
        },
    });
}
//# sourceMappingURL=cacheModel.js.map